










































































































































import BaseComponent from '@/components/base-component.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import UiAutocomplePatients from '@/components/UI/autocomplete-patients.vue';
import UiDatePicker from '@/components/UI/date-picker.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectClients from '@/components/UI/select-clients.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import { PaginationSyncDTO } from '@/interfaces/base-dto';
import { ProdutoUtilizadoDTO, ProdutoUtilizadoParmDTO } from '@/interfaces/prescription-hist';
import { buildUsedProductsXlsx, listProductsCombo, listUsedProducts } from '@/services/prescription-hist';
import { EMPTY, Subject } from 'rxjs';
import { catchError, debounceTime, skipWhile, switchMap, tap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiAutocompleClientsSubsidiaries,
    UiSelectClients,
    UiSelectDoctor,
    UiAutocomplePatients,
    UiDatePicker
  }
})
export default class UsedProductsReport extends BaseComponent {
  error = false;
  loading = false;
  loadingPdf = false;
  loadingXls = false;
  executed = false;
  filter = {
    clients: null,
    clientUnits: null,
    doctors: null,
    patients: null,
    idsProducts: null,
    fromDate: null,
    toDate: null,
    groupBy: ['C', 'U', 'M', 'P']
  };

  clientsIds = null;
  clientUnitsIds = null;

  items: ProdutoUtilizadoDTO[] = [];
  pagination: PaginationSyncDTO = new PaginationSyncDTO('cliente');
  private execBehaviorSub$: Subject<any> = new Subject();

  productsLoading = false;
  products = [];

  headers = [
    { text: 'Cliente', value: 'cliente', sortable: true },
    { text: 'Unidade', value: 'unidade', sortable: true },
    { text: 'Médico', value: 'medico', sortable: true },
    { text: 'Paciente', value: 'paciente', sortable: true },
    { text: 'Produto', value: 'produto', sortable: true },
    { text: 'Qtd. Total em mL', value: 'qtdeTotalMl', sortable: true, align: 'right' }
  ];

  groupByOptions = [
    { id: 'C', text: 'Cliente' },
    { id: 'U', text: 'Unidade' },
    { id: 'M', text: 'Médico' },
    { id: 'P', text: 'Paciente' }
  ];

  beforeMount() {
    this.pagination = Object.assign(new PaginationSyncDTO(), this.pagination);
  }

  mounted() {
    this.execBehaviorSub$
      .pipe(
        skipWhile((val) => {
          return val === null;
        }),
        debounceTime(500),
        tap(() => {
          this.loading = true;
        }),
        switchMap((parm) => {
          return listUsedProducts(parm).pipe(
            catchError((e) => {
              this.loading = false;
              this.error = true;
              return EMPTY;
            })
          );
        })
      )
      .subscribe((res) => {
        this.items = res.content;
        PaginationSyncDTO.update(this.pagination, res);
        this.loading = false;
        this.executed = true;
      });
    this.loadProductsCombo();
  }

  loadProductsCombo() {
    this.productsLoading = true;
    listProductsCombo().subscribe(
      (res) => {
        this.products = res;
        this.productsLoading = false;
      },
      (error) => {
        this.productsLoading = false;
        this.showToastApiError(error);
      }
    );
  }

  private buildFilterParm() {
    let parm = new ProdutoUtilizadoParmDTO();
    let filter = this.filter;
    parm.idsClientes = filter.clients ? filter.clients.map((u) => u.id) : [];
    parm.idsUnidades = filter.clientUnits ? filter.clientUnits.map((u) => u.id) : [];
    parm.idsMedicos = filter.doctors && filter.doctors.length ? filter.doctors.map((d) => d.id) : [];
    parm.idsPacientes = filter.patients && filter.patients.length ? filter.patients.map((d) => d.id) : [];
    parm.dataDe = filter.fromDate ? filter.fromDate : null;
    parm.dataAte = filter.toDate ? filter.toDate : null;
    parm.idsProdutos = filter.idsProducts;
    parm.agruparPor = filter.groupBy;

    parm.update(this.pagination);
    return parm;
  }

  public exec() {
    this.executed = false;
    this.loading = true;
    this.error = false;
    this.execBehaviorSub$.next(this.buildFilterParm());
  }

  public exportXlsx() {
    this.loader.start('Gerando XLSX...');
    this.loadingXls = true;
    let parm = this.buildFilterParm();

    buildUsedProductsXlsx(parm).subscribe(
      (res) => {
        this.loader.stop();
        this.loadingXls = false;
        this.forceFileAxiosResponseDownload(res, 'produtos_utilizados.xlsx');
      },
      (error) => {
        this.loader.stop();
        this.loadingXls = false;
        this.showToastApiError(error);
      }
    );
  }

  @Watch('filter.clients')
  private onClientChange(client) {
    this.clientsIds = this.filter.clients ? this.filter.clients.map(c => c.id) : []
  }

  @Watch('filter.clientUnits')
  private onClientUnitChange(unit) {
    this.clientUnitsIds = this.filter.clientUnits ? this.filter.clientUnits.map(c => c.id) : []
  }

  /*
  @Watch('filter.client')
  @Watch('filter.unit')
  @Watch('filter.doctors')
  @Watch('filter.patients')
  @Watch('filter.fromDate')
  @Watch('filter.toDate')
  */
  @Watch('pagination.page')
  @Watch('pagination.rowsPerPage')
  @Watch('pagination.sortBy')
  @Watch('pagination.descending')
  private onChangeFilter(val) {
    this.exec();
  }
}
